module.exports = __webpack_public_path__ + "img/logo-big.3ef8cf5b.png";